import React,{useEffect, useState, useRef} from 'react'
import "../css/Home.css";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import PostDetail from '../components/PostDetail';
import { formatCount } from '../utils/format';
import AdVideo from '../AdMedia/AdVideo.mp4';

export default function MyFollowingPost() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [comment, setComment] = useState("");
  const [show, setShow] = useState(false);
  const [item, setItem] = useState([]);
  const [expandedCaptions, setExpandedCaptions] = useState({});
  const [mediaIndices, setMediaIndices] = useState({});
  const [mediaPlaying, setMediaPlaying] = useState({});
  const limitRef = useRef(3);
  const skipRef = useRef(0);
  const loadingRef = useRef(false);
  const hasMoreRef = useRef(true);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const changeMediaIndex = (postId, direction, mediaLength) => {
    setMediaIndices(prev => {
      const currentIdx = prev[postId] || 0;
      const newIdx = direction === 'next' 
        ? (currentIdx + 1) % mediaLength 
        : (currentIdx - 1 + mediaLength) % mediaLength;
      return { ...prev, [postId]: newIdx };
    });
  }
  const playMedia = (postId) => setMediaPlaying(prev => ({...prev, [postId]: true}));
  const toggleCaption = (id) => setExpandedCaptions(prev => ({...prev, [id]: !prev[id]}));

  // Toast Functions
  const notifyA = (msg) => toast.error(msg)
  const notifyB = (msg) => toast.success(msg)

  useEffect(() =>{ 
    const token = localStorage.getItem("jwt");
    if(!token){
      navigate("./signup")
      return;
    }
    // initial fetch
    fetchPosts(true);

    // scroll listener for lazy loading
    const onScroll = () => {
      if (loadingRef.current || !hasMoreRef.current) return;
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 300) {
        fetchPosts();
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const fetchPosts = (reset = false) => {
    if (!reset && (loadingRef.current || !hasMoreRef.current)) return;
    loadingRef.current = true;
    setLoading(true);
    const limit = limitRef.current;
    const skip = reset ? 0 : skipRef.current;
    fetch(`/myfollowingpost?limit=${limit}&skip=${skip}`,{
      headers:{ Authorization: "Bearer " + localStorage.getItem("jwt") }
    })
    .then(res => res.json())
    .then(result => {
      const list = Array.isArray(result) ? result : [];
      setData(prev => {
        if (reset) return list;
        const existing = new Set(prev.map(p => p._id));
        const merged = [...prev];
        for (const r of list) if (!existing.has(r._id)) merged.push(r);
        return merged;
      });
      skipRef.current = reset ? list.length : (skipRef.current + list.length);
      if (list.length < limit) { setHasMore(false); hasMoreRef.current = false; }
      else { setHasMore(true); hasMoreRef.current = true; }
    })
    .catch(err => console.log(err))
    .finally(() => { loadingRef.current = false; setLoading(false); });
  }

  // loading indicator for UI (optional)
  // `loading` and `hasMore` are available for rendering a spinner or end message

  // show and hide comments
  const toggleComment = (posts)=>{
    if(show){
      setShow(false);
    }else{
      setShow(true);
      setItem(posts);
      
    }
  }


  const likePost = (id) =>{
    fetch("/like",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({
        postId:id
      })
    }).then(res=>res.json())
    .then((result)=>{
      const newData = data.map((posts)=>{
        if(posts._id === result._id){
          return result
        }else{
          return posts
        }
      })
      setData(newData)
      console.log(result)
    })
  }
  const unlikePost = (id) =>{
    fetch("/unlike",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({
        postId:id
      })
    }).then(res=>res.json())
    .then((result)=>{
      const newData = data.map((posts)=>{
        if(posts._id === result._id){
          return result
        }else{
          return posts
        }
      })
      setData(newData);
      console.log(result);
    })
  };

  // function to make comment
  const makeComment = (text,id) =>{
    if (!text || !text.trim()) { notifyA('Comment cannot be empty'); return; }
    if (text.length > 128) { notifyA('Comment cannot exceed 128 characters'); return; }
    fetch("/comment",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({
        text:text,
        postId:id,
      }),
    })
      .then(res=>res.json())
      .then((result)=>{
        const newData = data.map((posts)=>{
          if(posts._id === result._id){
            return result
          }else{
            return posts
          }
        })
        setData(newData);
        setComment("");
        notifyB("Comment Posted");
        console.log(result);
      });
  };

  return (
    <div className='home'>
          {/* card */}
          {data.map((posts, idx) => {
            return (
              <React.Fragment key={posts._id}>
                <div className="card">
                {/* card-header */}
                <div className="card-header">
                  <div className="card-pic">
                    <img src={posts.postedBy && (posts.postedBy.Photo || posts.postedBy.PhotoUrl) ? posts.postedBy.Photo || posts.postedBy.PhotoUrl : "https://cdn-icons-png.flaticon.com/128/1177/1177568.png"} alt="" />
                  </div>
                  <h5>
                    <Link to={`/profile/${posts.postedBy._id}`}>
                      {posts.postedBy.name}
                    </Link>
                  </h5>
                </div>
                {/* card image */}
                <div className="card-image" style={{position:'relative'}}>
                  {posts.media && posts.media.length > 0 ? (
                    <>
                      {(() => {
                        const idx = mediaIndices[posts._id] || 0;
                        const m = posts.media[idx];
                        if (m.type === 'image') return (<img src={m.url} alt="" />);
                        if (m.type === 'video') {
                          const isPlaying = mediaPlaying[posts._id];
                          if (m.thumbnail && !isPlaying) {
                            return (
                              <div style={{position:'relative', cursor: 'pointer'}} onClick={() => playMedia(posts._id)}>
                                <img src={m.thumbnail} alt="" style={{width:'100%'}} />
                                <div style={{position:'absolute',right:8,bottom:8,background:'rgba(0,0,0,0.5)',borderRadius:12,width:28,height:28,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:18}}>▶</div>
                              </div>
                            );
                          }
                          return (<video src={m.url} controls muted playsInline preload="metadata" style={{width:'100%'}} />);
                        }
                        return null;
                      })()}
                      {posts.media.length > 1 && (
                        <>
                          <button onClick={() => changeMediaIndex(posts._id, 'prev', posts.media.length)} style={{position:'absolute',top:'50%',left:0,transform:'translateY(-50%)',background:'rgba(0,0,0,0.3)',border:'none',color:'#fff',fontSize:'24px',cursor:'pointer',padding:'5px 10px'}}>‹</button>
                          <button onClick={() => changeMediaIndex(posts._id, 'next', posts.media.length)} style={{position:'absolute',top:'50%',right:0,transform:'translateY(-50%)',background:'rgba(0,0,0,0.3)',border:'none',color:'#fff',fontSize:'24px',cursor:'pointer',padding:'5px 10px'}}>›</button>
                        </>
                      )}
                    </>
                  ) : (
                    <img src={posts.photo} alt="" />
                  )}
                </div>

                {/* card-content */}
                <div className="card-content">
                  {
                    (() => {
                      const user = JSON.parse(localStorage.getItem('user') || 'null');
                      const userId = user && (user._id || user.id);
                      const likes = posts.likes || [];
                      const liked = userId ? likes.some(l => (typeof l === 'string' ? l === userId : (l._id === userId || l.id === userId))) : false;
                      return liked
                        ? (<span className="material-symbols-outlined material-symbols-outlined-red" onClick={() => { unlikePost(posts._id) }}>favorite</span>)
                        : (<span className="material-symbols-outlined" onClick={() => { likePost(posts._id) }}>favorite</span>);
                    })()
                  }
                  
                  

                  <p>{formatCount(posts.likes.length)} Likes</p>
                  <p>
                    {(() => {
                      const caption = posts.body || '';
                      const limit = 100;
                      const isExpanded = !!expandedCaptions[posts._id];
                      if (caption.length <= limit) return caption;
                      return (
                        <>
                          {isExpanded ? caption : `${caption.slice(0, limit)}...`}
                          <span onClick={() => toggleCaption(posts._id)} style={{color:'#0084ff',cursor:'pointer',marginLeft:6}}>{isExpanded ? 'Read less' : 'Read more'}</span>
                        </>
                      )
                    })()}
                  </p>
                  <p style={{fontWeight:"bold", cursor:"pointer"}} onClick={()=>{
                    toggleComment(posts);
                  }} >View all comments</p>
                </div>

                {/* add-comment */}
                <div className="add-comment">
                <span className="material-symbols-outlined">sentiment_satisfied</span>
                <input type="text" placeholder='Add a comment' value={comment} onChange={(e)=>{setComment(e.target.value.slice(0,128))}} maxLength={128} />
                <button 
                  className='comment' 
                  onClick={()=>{
                    makeComment(comment,posts._id);
                  }}
                >
                  Post
                </button>
                </div>
                </div>

                {/* Advertisement after every 3 posts */}
                {((idx + 1) % 3 === 0) && (
                  <div className="card ad-card" style={{padding:12,marginTop:12,marginBottom:12}}>
                    <div style={{fontWeight:'bold',marginBottom:8}}>Sponsored</div>
                    <div style={{position:'relative'}}>
                      <video src={AdVideo} controls style={{width:'100%',borderRadius:6}} preload="metadata" />
                    </div>
                    <div style={{display:'flex',gap:6,marginTop:8}}>
                      <a href="https://instagram.com/advertiser" target="_blank" rel="noopener noreferrer" style={{flex:1,textAlign:'center',padding:8,background:'#E1306C',color:'#fff',borderRadius:6,textDecoration:'none'}}>Instagram</a>
                      <a href="https://youtube.com/advertiser" target="_blank" rel="noopener noreferrer" style={{flex:1,textAlign:'center',padding:8,background:'#FF0000',color:'#fff',borderRadius:6,textDecoration:'none'}}>YouTube</a>
                    </div>
                  </div>
                )}
              </React.Fragment>
        )
      })}

      {loading && (
        <div style={{display:'flex',justifyContent:'center',padding:16}} className="infinite-spinner">
          <div className="spinner" aria-hidden="true"></div>
        </div>
      )}

      {/* show Comment (use shared PostDetail for consistent UI) */}
      {show && (
        <PostDetail item={item} toggleDetails={toggleComment} hideDelete={true} />
      )}
    </div>
  );
}

